const size = {
  sm: "1024px",
  desktop: "1025px"
};

const mq = (targetSize, minOrMax = "min") =>
  `@media screen and (${minOrMax}-width: ${size[targetSize]})`;

export default mq;
